import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
  border-radius: 6px;
  border: 1.5px solid #c9c9cb;

  > div {
    padding: 1rem;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 0.75rem 0.5rem;
`
